/* eslint-disable eslint-comments/disable-enable-pair -- needed */
import React from 'react';
import { useIntl } from 'react-intl';
import DOMPurify from 'dompurify';
import { ContinuousLinearTracker, Heading } from '@americanexpress/dls-react';
import MultiLevel from './MultiLevel';

const TrackersQuickView = (props) => {
  const intl = useIntl();
  const trackerData = props.trackerData?.tracker;
  const progressData = props.trackerData?.progress;
  const isAchieved = props?.trackerData?.status === 'ACHIEVED';
  const isInProgress = props?.trackerData?.status === 'IN_PROGRESS';
  const showProgressBar = isInProgress && !props?.trackerData?.hideProgressBar;
  const showMultiLevel = isInProgress && props?.trackerData?.multiLevel;

  const multiLevelData = props.trackerData?.multiLevel ? props?.trackerData?.levels : null;

  // i18n format currency vs non-currency
  const formattedAmount = (amount) => {
    let amnt = amount <= 0 ? 0 : amount;
    const convertToInt = Math.round(amnt).toLocaleString();

    // Temporary Fix....issue with intl...props are showing as undefined..locale, lang, formatNumber
    const numberOptions = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    };

    if (props?.isCurrency) {
      return `${trackerData?.targetCurrencySymbol}${convertToInt}`;
    }
    return intl?.formatNumber(amnt, numberOptions);
  };

  // get formatted amounts
  const progressBarLeftText = `${formattedAmount(trackerData?.spentAmount)} ${progressData?.usedLabel}`;
  const progressBarRightText = `${formattedAmount(trackerData?.remainingAmount)} ${progressData?.togoLabel}`;

  // Format to whole numbers only for aira values
  const formatAiraValue = (amount) => {
    const wholeAmount = amount / 1;
    return wholeAmount;
  };

  const numericSpendAmount = formatAiraValue(trackerData?.spentAmount);
  const numericTargetAmount = formatAiraValue(trackerData?.targetAmount);

  return (
    <>
      { isAchieved
         && (
           <div className="margin-2-b">
             <Heading level={4} variant="sans-xsmall-regular" data-testid="Congratulations" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(progressData?.message) }} />
           </div>
         )}
      {showProgressBar && (
      <div className="margin-1-t">
        <ContinuousLinearTracker
          labelOverrides={{
            getScreenReaderLabel: () => 'Progress in attaining this reward',
            getScreenReaderValueText: () => numericSpendAmount,
            getTrackerEndText: () => progressBarRightText,
            getTrackerStartText: () => progressBarLeftText,
          }}
          max={numericTargetAmount}
          min={0}
          value={numericSpendAmount}
        />
        {showMultiLevel
          ? (
            <>
              <div className="margin-1-tb">
                <Heading level={4} variant="sans-xsmall-regular" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(progressData?.message) }} />
              </div>
              <hr />
              <MultiLevel data={multiLevelData} />
            </>
          )
          : ''}
      </div>
      )}
    </>
  );
};

export default TrackersQuickView;
